module.exports = __webpack_public_path__ + "img/ExaminationPaperRepository.76d1dcb9.png";